import { get } from 'lodash';

import { PayloadApiRequest } from '../actions/sagaApi';
import { parseDate } from '../services/datesService';

import appointmentsResource from './appointmentsResource';
import appointmentTypesResource from './appointmentTypesResource';
import createResource from './createResource';
import facilitiesResource from './facilitiesResource';
import providersResource from './providersResource';
import { Availability } from './types';

// isSchedulerV2 is temporary -> until we finish rolling out all scheduler v2 BE code
export const availabilitiesResource = (isSchedulerV2 = false) => createResource<Availability>({
  key: 'availabilities',
  url: '/availabilities',
  fetchPageUrl: isSchedulerV2 ? '/v2/availabilities/scheduler' : '/scheduler/availabilities',
  hasFetchBulkSupport: true,
  lookups: {
    appointmentType: appointmentTypesResource,
    createdFromAppointment: appointmentsResource,
    usedForAppointment: appointmentsResource,
    facility: facilitiesResource,
    provider: providersResource,
  },
  processStrategy: (data) => ({
    ...data,
    $date: parseDate(data.date),
    $toString: `[${data.status}] ${data.$toString}`,
  }),
});

const baseAvailabilitiesResource = availabilitiesResource();

const customActions = {
  bookAppointment: (availabilityId: Availability['id'], payload?: PayloadApiRequest<Availability>) =>
    baseAvailabilitiesResource.request({
      url: `${baseAvailabilitiesResource.url}/${availabilityId}/book`,
      method: 'put',
      ...payload,
      meta: {
        schema: availabilitiesResource().schema,
        messageSuccess: 'Book success!',
        messageError: 'There was a problem booking the appointment. Please try again',
        ...get(payload, 'meta'),
      },
    }),
};

export default {
  ...baseAvailabilitiesResource,
  ...customActions,
};
